module.exports = __webpack_public_path__ + "img/icn_logout.f49ebcf7.svg";